import graphql from "babel-plugin-relay/macro";
import { useAtomValue, useSetAtom } from "jotai";
import { useFragment } from "react-relay";

import { setGroupSizeAtom } from "@/features/BookingWizard/atoms/actions/setGroupSize/setGroupSizeAtom";
import { BookingWizardDataAtom } from "@/features/BookingWizard/atoms/stores";

import { GroupSizeControlBase } from "./GroupSizeControlBase";
import { RequestGroupSizeControlNode$key } from "./__generated__/RequestGroupSizeControlNode.graphql";

type RequestProps = {
  nodeRef: RequestGroupSizeControlNode$key | null;
};

export const RequestGroupSizeControl = ({ nodeRef }: RequestProps) => {
  const wizardData = useAtomValue(BookingWizardDataAtom);
  const node = useFragment(RequestGroupSizeControlFragmentString, nodeRef);
  const currentGroupSize = wizardData?.groupSize;
  const setGroupSize = useSetAtom(setGroupSizeAtom);

  const capacity = node?.__typename === "QueueSlot" ? node?.capacity ?? 1 : 1;

  // For request bookings, assume the slot is empty (usedCapacity = 0)
  const usedCapacity = 0;

  return (
    <GroupSizeControlBase
      capacity={capacity}
      usedCapacity={usedCapacity}
      // Default to 1 if currentGroupSize is 0, since the filter may pass 0 by default
      // but we want at least 1 person for a booking
      currentGroupSize={currentGroupSize === 0 ? 1 : currentGroupSize ?? 1}
      setGroupSize={setGroupSize}
    />
  );
};

export const RequestGroupSizeControlFragmentString = graphql`
  fragment RequestGroupSizeControlNode on Node {
    __typename
    ... on QueueSlot {
      id
      capacity(bookingType: STANDARD)
    }
  }
`;
